import { Component, OnInit } from '@angular/core';
import { HomeDashboardService } from '../../data/services/view/home-dashboard.service';

@Component({
  selector: 'app-assets',
  templateUrl: './assets.component.html',
  styleUrls: ['./assets.component.scss']
})
export class AssetsComponent implements OnInit {
  assets: any[] = [];
  categoryChartData: any;
  chartOptions: any;
  totalAssets: number = 0;

  constructor(private readonly dashboardService: HomeDashboardService) { }

  ngOnInit(): void {
    this.dashboardService.assets().subscribe((response) => {
      this.assets = response.data;
      this.prepareChart();
    });

    this.chartOptions = {
      responsive: true,
      plugins: {
        legend: {
          position: 'right',
          labels: {
            usePointStyle: true,
          }
        }
      },
      maintainAspectRatio: false,
    };
  }

  prepareChart() {
    if (!this.assets.length) return;

    const categoryCounts = this.countByField('category');
    this.totalAssets = this.assets.length;

    this.categoryChartData = {
      labels: Object.keys(categoryCounts),
      datasets: [
        {
          data: Object.values(categoryCounts),
          backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726', '#AB47BC', '#EF5350']
        }
      ]
    };
  }

  countByField(field: string): { [key: string]: number } {
    return this.assets.reduce((acc, item) => {
      acc[item[field]] = (acc[item[field]] || 0) + 1;
      return acc;
    }, {} as { [key: string]: number });
  }
}
